import React, { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../utils/ellowutils';
import SideMenu from '../sideMenu'
import DashboardHeader from '../topbar';
import * as CONSTANTS from '../../utils/CONSTANTS'
import TotalInfoCards from './totalInfoCards';
import ActivePositions from './ActivePositions';
import ClosedPositions from './closedPositions';
import PositionStatus from './positionStatus';
import { getAllResources, getChartData, getPositions, getPositionsCount} from './services';
import { viewedpageMixpanel } from '../../utils/mixpanel';

function Dashboard() {

  const loginId = localStorage.getItem('loginId')
  const customerId = localStorage.getItem('customerId')


    const menu = makeSideBarActive(CONSTANTS.sideMenu, 0)
    const breadCrums = ['Dashboard']

  const [countData, setCountData] = useState<any>()
  const [upcomingJoineeData, setUpcomingJoineeData] = useState<any>()
  const [activePositions, setActivePositions] = useState<any>()
  const [closedPositions, SetClosedPositions] = useState<any>()
  const [chartData, setChartData] = useState<any>()

  useEffect(() => {
    
    getCustomerPositionCount()
    getupcomingJoinee()
    getAllPositions();
    getClosedPositions()
    getDashboardChartdata()
    viewedpageMixpanel();
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  const getDashboardChartdata = (filters?: any) => {

    getChartData(customerId).then((response) => {
      if (response && response.status === 1) {        
       setChartData(response.data)
     }
   })
 }

  const getupcomingJoinee = (filters?: any) => {

    let body = {
      filters: filters ? filters : {}
    }
    getAllResources(customerId,'upcoming', 1, 5, '', body).then((response) => {
      if (response && response.status === 1) {
        setUpcomingJoineeData(response.data)
      }
    })
  }

  const getAllPositions = (filters?: any) => {

    let data = {
       positionType: 'active',
      login_id: loginId,
      filters:filters ? {
        companyId: customerId,
        dateWithin: filters.dateWithin
      } :
        { companyId : customerId}
     }
 
     getPositions("", 1, 5, data).then((resp) => {
       if (resp && resp.status === 1) {
         setActivePositions(resp.data)
       }
     })
   }

  const getClosedPositions = (filters?: any) => {

    let data = {
      positionType: 'closed',
      login_id: loginId,
      filters:filters ? {
        companyId: customerId,
        dateWithin: filters.dateWithin
      } :
        { companyId : customerId}
      }
    getPositions("", 1, 5, data).then((resp) => {
      if (resp && resp.status === 1) {
        sortByDescending(resp.data)
      }
    })
  }

  const sortByDescending =(data: any) => {
    let sortedDescending = data.sort((a: any, b: any) => {
      return b.resourceCount - a.resourceCount
    })
    SetClosedPositions(sortedDescending)
  }

  const getCustomerPositionCount = (filters?: any) => {

    let body = {
      filters: filters ? filters : {}
    }
    getPositionsCount(customerId, body).then((response) => {
      if (response && response.status === 1) {
        setCountData(response.data[0])
      }
    })
  }

  const filterChange = (data: any) => {
    if (data) {
      getCustomerPositionCount({ dateWithin: { from: data.from, to: data.to } })
      getupcomingJoinee({ dateWithin: { from: data.from, to: data.to } })
      getAllPositions({ dateWithin: { from: data.from, to: data.to } });
      getClosedPositions({ dateWithin: { from: data.from, to: data.to } })
      getDashboardChartdata({ dateWithin: { from: data.from, to: data.to } })
    } else {
      getCustomerPositionCount()
      getupcomingJoinee()
      getAllPositions();
      getClosedPositions()
      getDashboardChartdata()
    }

  }
    
  return (
      
      
    <section className="dashboardWrapper">
      <SideMenu menu={menu}/>
      <div className="dashboardContent">
        <DashboardHeader title={breadCrums} searchChange={undefined} type='dashboard' applyDashboardFilter={filterChange}/>
        <TotalInfoCards data={countData} />
        {/* <SubmittedCandidates/> */}
        <ActivePositions data={activePositions} />
        <ClosedPositions data={closedPositions}/>
        <PositionStatus tableData={upcomingJoineeData} chartData={chartData} />
        {/* <iframe src="https://d3cquokp8zwnyp.cloudfront.net/lex-web-ui-loader.min.js" width={1000} height={500} title='A youtube video on React hooks'></iframe> */}
      </div>
    </section>
  
  )
}

export default Dashboard